import { render } from "./WorkingSiteAssignedUsersSection.vue?vue&type=template&id=804d6e56&scoped=true&ts=true&lang=pug"
import script from "./WorkingSiteAssignedUsersSection.vue?vue&type=script&lang=ts"
export * from "./WorkingSiteAssignedUsersSection.vue?vue&type=script&lang=ts"

import "./WorkingSiteAssignedUsersSection.vue?vue&type=style&index=0&id=804d6e56&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804d6e56"]])

export default __exports__